export default __webpack_public_path__ + "static/SR USA - Propuesta 65 de California - Declaración-e2cb328f99087363ff49847247b64222.pdf";